import { useState } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { CardContent } from 'shared-components';
import { FormLayout } from 'shared-components';
import { Button, ButtonIntent, ButtonTier } from 'shared-components';
import { Input } from 'shared-components';
import { Checkbox } from 'shared-components';
import styles from './settings.module.css';
import { INavigationItem } from '@topshots/core-models';

export const SettingsNavigation = () => {
  const { values, setFieldValue } = useFormikContext<{
    topNavItems: INavigationItem[];
  }>();

  const [dragging, setDragging] = useState<number | null>(null);

  return (
    <CardContent>
      <FormLayout>
        <h1>Navigation</h1>
        <p>Add links to your gallery's top navigation bar.</p>

        <FieldArray name="topNavItems">
          {({ push, remove, move }) => (
            <div className={styles.navItems}>
              {values.topNavItems.map((item, index) => (
                <div
                  key={index}
                  className={`${styles.navItem} ${
                    dragging === index ? styles.navItemDragging : ''
                  }`}
                  draggable
                  onDragStart={() => setDragging(index)}
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                  onDrop={() => {
                    if (dragging === null || dragging === index) return;
                    move(dragging, index);
                    // Update order fields to match new positions
                    const updated = [...values.topNavItems];
                    const [moved] = updated.splice(dragging, 1);
                    updated.splice(index, 0, moved);
                    updated.forEach((item, i) => {
                      setFieldValue(`topNavItems.${i}.order`, i);
                    });
                    setDragging(null);
                  }}
                  onDragEnd={() => setDragging(null)}
                >
                  <span className={styles.navItemDragHandle}>⋮⋮</span>

                  <Input
                    type="text"
                    placeholder="Title"
                    value={item.title}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setFieldValue(
                        `topNavItems.${index}.title`,
                        e.target.value
                      )
                    }
                  />

                  <Input
                    type="text"
                    placeholder="URL"
                    value={item.url}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setFieldValue(`topNavItems.${index}.url`, e.target.value)
                    }
                  />

                  <Checkbox
                    type="checkbox"
                    label="New window"
                    checked={item.newWindow}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setFieldValue(
                        `topNavItems.${index}.newWindow`,
                        e.target.checked
                      )
                    }
                  />

                  <Button
                    intent={ButtonIntent.Negative}
                    tier={ButtonTier.Secondary}
                    onClick={() => remove(index)}
                  >
                    Remove
                  </Button>
                </div>
              ))}

              <div>
                <Button
                  intent={ButtonIntent.Positive}
                  tier={ButtonTier.Secondary}
                  onClick={() =>
                    push({
                      title: '',
                      url: '',
                      order: values.topNavItems.length,
                      newWindow: false,
                    })
                  }
                >
                  Add Item
                </Button>
              </div>
            </div>
          )}
        </FieldArray>
      </FormLayout>
    </CardContent>
  );
};
